import axiosInstance from '@/config/http.config.js'
import router from '@/router'
import { useAuthStore } from '@/features/auth/stores/AuthStore.js'

export function setupInterceptors() {
  // Interceptor de solicitud
  axiosInstance.interceptors.request.use(
    config => {
      const authStore = useAuthStore()
      const token = authStore.token

      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    error => Promise.reject(error)
  )

  // Interceptor de respuesta
  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      const authStore = useAuthStore()
      const currentPath = router.currentRoute.value.path

      // Solo redirige a login si NO está ya en la ruta de login
      if (error.response?.status === 401 && currentPath !== '/auth/login') {
        authStore.logout()
        router.push('/auth/login')
      }

      return Promise.reject(error)
    }
  )
}